import React from 'react';

import ProductImage from '../../../components/aurora/ProductImage';
import ColumnFilterSort from '../../../components/tableServerSide/ColumnFilterSort';
import ToolTip from '../../../components/ToolTip';

const getReturnableIsInvalidValue = input => {
  switch (input?.toLowerCase()) {
    case 'yes':
      return 'true';
    case 'no':
      return 'false';
    default:
      return input;
  }
};

export const columnSortModifiersCatalogProductsList = {
  name: null,
  productCode: null,
  returnable: null,
  isInvalid: null,
  defaultSort: {}
};

export const columnFilterModifiersCatalogProductsList = {
  name: { expression: 'Like' },
  productCode: { expression: 'Like' },
  returnable: { expression: '', value: input => getReturnableIsInvalidValue(input) },
  isInvalid: { expression: '', value: input => getReturnableIsInvalidValue(input) }
};

export const getCatalogProductsListColumns = () => {
  return [
    {
      id: 'image',
      Header: 'Image',
      accessor: d => d.productCode,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => (
        <div className='d-sm-flx flx-jc-sm-c'>
          <ProductImage productCode={value} alt={value} width={35} height={35} magnify />
        </div>
      ),
      width: 45
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Name' tableInstance={tableInstance} />,
      width: 300,
      accessor: 'name',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => (
        <div>
          {/* eslint-disable-next-line react/prop-types */}
          {value?.toUpperCase()}
        </div>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Product Code' tableInstance={tableInstance} />,
      width: 300,
      accessor: 'productCode'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Is Returnable' tableInstance={tableInstance} />,
      accessor: 'returnable',
      id: 'returnable',
      Cell: ({ value }) => (value ? 'Yes' : 'No'),
      width: 300
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Is Invalid' tableInstance={tableInstance} />,
      accessor: 'isInvalid',
      id: 'isInvalid',
      Cell: row =>
        row?.value ? (
          <span data-testid='invalid-product-tooltip'>
            <ToolTip position='left' title={row?.row?.original?.invalidReasons?.join('; ')}>
              Yes
            </ToolTip>
          </span>
        ) : (
          'No'
        ),
      width: 300
    }
  ];
};
